import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'app-version',
    templateUrl: './version.component.html',
    styleUrls: ['./version.component.scss'],
})
export class VersionComponent implements OnInit {
    @Input() dark: boolean = false;
    constructor() {}

    ngOnInit() {}
}
